import AssetType from 'common/enums/assetTypes';
import Download from './components/Download';
import PromotionalBannerText from './components/PromotionalBannerText';
import ShowMe from './components/ShowMe';

const CallToActionItemPreview = (props) => {
    const { callToAction, disabled, size = 'big' } = props;

    const renderPreview = () => {
        switch (callToAction.callToActionType) {
            case AssetType.PROMOTION:
                return <PromotionalBannerText disabled={disabled} key={callToAction.id} promotion={callToAction} />;
            case AssetType.DOWNLOAD:
                return <Download size={size} disabled={disabled} key={callToAction.id} asset={callToAction} />;
            case AssetType.SHOWME:
                return <ShowMe size={size} disabled={disabled} key={callToAction.id} asset={callToAction} />;
            default:
                return null;
        }
    };

    return <>{renderPreview()}</>;
};

export default CallToActionItemPreview;
